/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const DictionaryTypeDto = {
    CarType: 'CAR_TYPE',
    DietaryPreference: 'DIETARY_PREFERENCE',
    EmergencyContactCategoryType: 'EMERGENCY_CONTACT_CATEGORY_TYPE',
    MenuType: 'MENU_TYPE',
    PackageOfferItem: 'PACKAGE_OFFER_ITEM',
    PredefinedOffer: 'PREDEFINED_OFFER',
    Room: 'ROOM',
    SupplierType: 'SUPPLIER_TYPE',
    Tag: 'TAG',
} as const;

export type DictionaryTypeDto = typeof DictionaryTypeDto[keyof typeof DictionaryTypeDto];



